export let addressElements = [
    'House Number',
    'Interior Number',
    'Street Name', 
    'City Name',
    'State Name',
    'Country Name',
    'Postal Code'
];